// @ts-nocheck

import axios from "axios";
import { useEffect, useState } from "react";
import Select, { StylesConfig, MultiValue } from "react-select";
import colors from "tailwindcss/colors";
import useStoreTimToa from "../store/useStoreTimToa";

type Option = {
  value: string;
  label: string;
};

function formatToSelect(options: string[]) {
  return options.map((option) => {
    const value = option.split(" - ")[0];
    return {
      value,
      label: option,
    };
  });
}

const customStyles: StylesConfig<Option, true> = {
  control: (provided) => ({
    ...provided,
    outline: "none",
    boxShadow: "none",
    backgroundColor: colors.gray[200],
    color: colors.white,
    borderColor: colors.zinc[800],
    height: `${parseInt(provided.height as string) + 2}px`,
    minHeight: `${parseInt(provided.minHeight as string) + 2}px`,
    "&:hover": {
      borderColor: colors.zinc[800],
      backgroundColor: colors.zinc[800],
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: colors.zinc[950],
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? colors.gray[700] : colors.zinc[950],
    color: colors.white,
    "&:active": {
      backgroundColor: colors.zinc[600],
    },
    "&:hover": {
      backgroundColor: colors.zinc[700],
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: colors.gray[700],
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: colors.white,
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: colors.white,
    "&:hover": {
      backgroundColor: colors.gray[400],
      color: colors.white,
    },
  }),
};

export function SelectCenterCost() {
  const [selectedOptions, setSelectedOptions] = useState<MultiValue<Option>>([]);
  const [options, setOptions] = useState<Option[]>([]);
  const { setCenterCost } = useStoreTimToa((state) => state);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setCenterCost(selectedOptions);
  }, [selectedOptions]);

  useEffect(() => {
    (async function fetchData() {
      try {
        setIsLoading(true);
        const { data } = await axios.get(
          "https://radar.tlpservicos.com.br/api/toa/centros-custo"
        );

        setOptions([
          { value: "all", label: "Todos" },
          ...formatToSelect(data.centros_custo),
        ]);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  const handleChange = (selected: MultiValue<Option>) => {
    const allOption = options.find((option) => option.value === "all");
    const wasAllSelected = selectedOptions.some((option) => option.value === "all");
    const isAllSelected = selected.some((option) => option.value === "all");

    if (isAllSelected && !wasAllSelected) {
      // Se "Todos" foi selecionado e não estava antes, seleciona apenas "Todos"
      setSelectedOptions(allOption ? [allOption] : []);
    } else if (!isAllSelected && wasAllSelected) {
      // Se "Todos" estava selecionado e agora não está, seleciona apenas o novo item
      const newSelection = selected.filter((option) => option.value !== "all");
      setSelectedOptions(
        newSelection.length > 0 ? [newSelection[newSelection.length - 1]] : []
      );
    } else if (isAllSelected && wasAllSelected) {
      const removeAll = selected.filter((opt) => opt.value !== "all");
      // Se "Todos" já estava selecionado e foi clicado em outro item, desmarca "Todos"
      setSelectedOptions([...removeAll]);
    } else {
      // Para outras seleções, atualiza normalmente
      setSelectedOptions(selected);
    }
  };

  return (
    <div className="w-[500px]">
      <Select<Option, true>
        isMulti
        options={options}
        styles={customStyles}
        value={selectedOptions}
        onChange={handleChange}
        className="mb-2 bg-gray-200"
        closeMenuOnSelect={false}
        placeholder={isLoading ? "Carregando..." : "Selecione..."}
        isLoading={isLoading}
        loadingMessage={() => "Carregando..."}
        noOptionsMessage={() => "Nenhuma opção encontrada"}
      />
    </div>
  );
}
